export default __webpack_public_path__ + "static/media/mark.f87eb285.svg";